import { Injectable } from '@angular/core';
import { drawerEnter, drawerLeave } from '@animations/modal-drawer';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class DrawerModalService {
  constructor(private modalController: ModalController) {}

  async presentModal(
    component: any,
    componentProps: any,
    size: string = 'sm',
    backdropDismiss: boolean = false,
    layeredModal: boolean = false,
    id: string = 'drawer-modal',
  ) {
    const modal = await this.modalController.create({
      component: component,
      componentProps: componentProps,
      cssClass: layeredModal ? ['layered-modal', 'drawer-style-' + size] : 'drawer-style-' + size,
      enterAnimation: drawerEnter,
      leaveAnimation: drawerLeave,
      backdropDismiss: backdropDismiss,
      id: id,
    });

    return await modal.present();
  }

  dismissModal(id?: string) {
    this.modalController.dismiss(undefined, undefined, id ? id : 'drawer-modal');
  }
}
